import * as React from 'react';
import Block from "@layout/Block";
import Font from "@layout/Font";
import { PieceDescription } from '@store/index';

interface Props {
    piece: PieceDescription;
}

const DescriptionPiece = ({ piece }: Props) => (
    <Block indent="30">
        {
            piece.title &&
            <Block indent="20">
                <div className="grid">
                    <div className="grid-6 line-bottom">
                        <Font font="primary">
                            { piece.title }
                        </Font>
                    </div>
                </div>
            </Block>
        }

        <Font font="secondary" size={20} lineHeight={1.4}>
            <div dangerouslySetInnerHTML={{ __html: piece.description }} />
        </Font>
    </Block>
);

export default DescriptionPiece;


// WEBPACK FOOTER //
// ./src/components/layout/pieces/Description/index.tsx